import { createSingleSPA } from 'mf-config/client';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';

const reactLifecycles = createSingleSPA({
  React,
  ReactDOM,
  RootComponent: () => <App />,
});

export const bootstrap = [reactLifecycles.bootstrap];

export const mount = [reactLifecycles.mount];

export const unmount = [reactLifecycles.unmount];
